import moment from "moment"

export const INSURANCE_STATUS_DEFAULT = 0
export const INSURANCE_STATUS_ENROLL = 1
export const INSURANCE_STATUS_CANCEL = 2
export const INSURANCE_STATUS_REFUSE = 3

const INSURANCE_STATUS_ENROLL_STRING = "加保中"
const INSURANCE_STATUS_CANCEL_STRING = "已退保"
const INSURANCE_STATUS_REFUSE_STRING = "不加保"

export const INSURANCE_TYPE_ENROLL_3IN1 = 1
export const INSURANCE_TYPE_ENROLL_2IN1 = 2
export const INSURANCE_TYPE_ENROLL_HEALTH = 3
export const INSURANCE_TYPE_ENROLL_GROUP = 4


export const INSURANCE_TYPE_CANCEL_3IN1 = 5
export const INSURANCE_TYPE_CANCEL_2IN1 = 6
export const INSURANCE_TYPE_CANCEL_HEALTH = 7
export const INSURANCE_TYPE_CANCEL_GROUP = 8

const TYPE_ENROLL_3IN1_STRING = "三合一加保作業"
const TYPE_ENROLL_2IN1_STRING = "二合一加保作業"
const TYPE_ENROLL_HEALTH_STRING = "全民健康保險加保作業"
const TYPE_ENROLL_GROUP_STRING = "團體保險加保作業"

const TYPE_CANCEL_3IN1_STRING = "三合一退保作業"
const TYPE_CANCEL_2IN1_STRING = "二合一退保作業"
const TYPE_CANCEL_HEALTH_STRING = "全民健康保險退保作業"
const TYPE_CANCEL_GROUP_STRING = "團體保險退保作業"

export const InsuranceEnrollType_Arr = [
    { val: INSURANCE_TYPE_ENROLL_3IN1, name: TYPE_ENROLL_3IN1_STRING },
    { val: INSURANCE_TYPE_ENROLL_2IN1, name: TYPE_ENROLL_2IN1_STRING },
    { val: INSURANCE_TYPE_ENROLL_HEALTH, name: TYPE_ENROLL_HEALTH_STRING },
    { val: INSURANCE_TYPE_ENROLL_GROUP, name: TYPE_ENROLL_GROUP_STRING },
]

export const InsuranceCancelType_Arr = [
    { val: INSURANCE_TYPE_CANCEL_3IN1, name: TYPE_CANCEL_3IN1_STRING },
    { val: INSURANCE_TYPE_CANCEL_2IN1, name: TYPE_CANCEL_2IN1_STRING },
    { val: INSURANCE_TYPE_CANCEL_HEALTH, name: TYPE_CANCEL_HEALTH_STRING },
    { val: INSURANCE_TYPE_CANCEL_GROUP, name: TYPE_CANCEL_GROUP_STRING },
]


export const InsuranceStatus_Arr = [
    { val: INSURANCE_STATUS_ENROLL, name: INSURANCE_STATUS_ENROLL_STRING },
    { val: INSURANCE_STATUS_CANCEL, name: INSURANCE_STATUS_CANCEL_STRING },
]
export const HealthInsuranceStatus_Arr = [
    { val: INSURANCE_STATUS_ENROLL, name: INSURANCE_STATUS_ENROLL_STRING },
    { val: INSURANCE_STATUS_CANCEL, name: INSURANCE_STATUS_CANCEL_STRING },
    { val: INSURANCE_STATUS_REFUSE, name: INSURANCE_STATUS_REFUSE_STRING },
]

export class ReqInsurance {
    /**
     * @param {string} caseContractor   外派員工Id
     * @param {json} insuranceInfo   保險內容
     */
    constructor({ caseContractor = "", recruitmentContractorId="", insuranceInfo = "" }) {
        this.caseContractor = caseContractor
        this.recruitmentContractorId = recruitmentContractorId
        this.insuranceInfo = insuranceInfo
    }
    fromJson(jsonData) {
        if (jsonData === undefined)
            jsonData = {}
        // console.log(jsonData)
        // console.log(jsonData.caseContractor)
        this.caseContractor = jsonData.caseContractor || ""
        this.recruitmentContractorId = jsonData.recruitmentContractorId || ""
        this.insuranceInfo = jsonData.insuranceInfo || new RespInsurance({})
    }
}
/**
 * 保險
 */

export class RespInsurance {
    /**
     * 
     * @param {string} insuranceUnitGUI   勞健保投保單位統編
     * @param {object} laborInsurance   勞保
     * @param {string} laborPension     勞退
     * @param {string} healthInsurance  健保
     * @param {string} groupInsurance   團保
     */
    constructor({ insuredUnitGUI = "", laborInsurance, /*laborPension, */healthInsurance, groupInsurance }) {
        this.insuredUnitGUI = insuredUnitGUI
        this.laborInsurance = laborInsurance || new ReqLaborInsurance({})
        // this.laborPension = laborPension || new ReqLaborPension({})
        this.healthInsurance = healthInsurance || new ReqHealthInsurance({})
        this.groupInsurance = groupInsurance || new ReqGroupInsurance({})
    }

    fromJson(jsonData) {
        if (jsonData === undefined)
            jsonData = {}
        if (typeof (jsonData) === 'string')
            try {
                jsonData = JSON.parse(jsonData)
            } catch (error) {

            }
        this.insuredUnitGUI = jsonData.insuredUnitGUI || ""
        this.laborInsurance = new ReqLaborInsurance({})
        console.log(jsonData.laborInsurance)
        this.laborInsurance.fromJson(jsonData.laborInsurance )
        // this.laborPension = jsonData.laborPension || new ReqLaborPension({})
        this.healthInsurance = new ReqHealthInsurance({})
        this.healthInsurance.fromJson(jsonData.healthInsurance)
        this.groupInsurance =  new ReqGroupInsurance({})
        this.groupInsurance.fromJson(jsonData.groupInsurance)
    }
}

export class InsuranceBase {
    /**
     * 
     * @param {int} status  團保狀態參數    1-加保中, 2-已退保
     * @param {date} date   產生狀態的日期
     */
    constructor({ status = INSURANCE_STATUS_DEFAULT, date = "" }) {
        this.status = parseInt(status)
        this.date = date
    }
    fromJson(jsonData) {
        this.status = jsonData.status||INSURANCE_STATUS_DEFAULT
        this.date = jsonData.date||""
    }

    setDescription(status, date, amount) {
        var description = ""
        var dateString = moment(date).format('YYYY/MM/DD')
        var amountString = amount === null ? "" : "、" + amount.toLocaleString('en-US')
        if (status === INSURANCE_STATUS_ENROLL) {
            description = INSURANCE_STATUS_ENROLL_STRING + "、" + dateString + amountString
        } else if (status === INSURANCE_STATUS_CANCEL) {
            description = INSURANCE_STATUS_CANCEL_STRING + "、" + dateString + amountString
        } else if (status === INSURANCE_STATUS_REFUSE) {
            description = INSURANCE_STATUS_REFUSE_STRING + "、" + dateString
        } else {
            description = "N/A"
        }
        // console.log(description)
        this.description = description
    }
}

/**
 * 團保
 */
export class ReqGroupInsurance extends InsuranceBase {
    /**
     * 
     * @param {date} groupInsuranceGUI    保險公司統編
     */
    constructor({ status, date = "", groupInsuranceGUI = "" }) {
        super({ status, date })
        this.groupInsuranceGUI = groupInsuranceGUI
        super.setDescription(this.status, this.date, null)
    }
    fromJson(jsonData) {
        if (jsonData === undefined)
            jsonData = {}
        super.fromJson(jsonData)
        this.groupInsuranceGUI = jsonData.groupInsuranceGUI||""
        super.setDescription(this.status, this.date, null)
    }
}

/**
 * 勞保
 */
export class ReqLaborInsurance extends InsuranceBase {
    /**
     * 
     * @param {int} status  勞保狀態參數    1-加保中, 2-已退保
     * @param {date} date   產生狀態的日期
     * @param {int} amount  投保級距金額
     * @param {int} level  投保級距
     */
    constructor({ status, date, amount = 0, level = "" }) {
        super({ status, date })
        this.amount = amount
        this.level = level
        super.setDescription(this.status, this.date, this.amount)
    }
    fromJson(jsonData) {
        if (jsonData === undefined)
            jsonData = {}
        super.fromJson(jsonData)
        this.amount = jsonData.amount||0
        this.level = jsonData.level||""
        super.setDescription(this.status, this.date, this.amount)
    }
}

/**
 * 勞退
 */
export class ReqLaborPension extends ReqLaborInsurance {
    /**
     * 
     * @param {int} status  勞退狀態參數    1-加保中, 2-已退保
     * @param {date} date   產生狀態的日期
     * @param {int} amount  投保級距金額
     */
    // constructor({ status, date, amount }) {
    //     this.status = status
    //     this.date = date
    //     this.amount = amount
    // }
    // fromJson(jsonData) {
    //     this.status = jsonData.status
    //     this.date = jsonData.date
    //     this.amount = jsonData.amount
    // }
}

/**
 * 健保
 */
export class ReqHealthInsurance extends ReqLaborInsurance {
    /**
     * 
     * @param {int} status  健保狀態參數    1-加保中, 2-已退保
     * @param {date} date   產生狀態的日期
     * @param {int} amount  投保級距金額
     * @param {int} level  投保級距
     */
    // constructor({ status, date, amount }) {
    //     this.status = status
    //     this.date = date
    //     this.amount = amount
    // }
    // fromJson(jsonData) {
    //     this.status = jsonData.status
    //     this.date = jsonData.date
    //     this.amount = jsonData.amount
    // }
}

/**
 * 取得待加(退)保列表
 */
export class ReqInsuranceList {
    /**
     * 
     * @param {int} insuranceType  哪種作業方式
     */
    constructor({ companyId, insuranceType, start = 0, limit = 10 }) {
        this.companyId = companyId
        this.insuranceType = insuranceType
        this.start = start
        this.limit = limit
    }
    fromJson(jsonData) {
        this.companyId = jsonData.companyId
        this.insuranceType = jsonData.insuranceType
        this.start = jsonData.start || 0
        this.limit = jsonData.limit || 10
    }
}

export class RespInsuranceListItem {
    constructor({ item, insurance }) {
        this.isChoose = false
        this.item = item
        this.insurance = insurance
    }
    fromJson(jsonData) {
        this.isChoose = jsonData.isChoose
        this.item = jsonData.item
        this.insurance = jsonData.insurance
        // this.insurance = new ReqInsurance({
        //     caseContractor: jsonData.caseContractor,
        //     insuranceInfo: new RespInsurance({
        //         laborInsurance: new ReqLaborInsurance({}),
        //         healthInsurance: new ReqHealthInsurance({}),
        //         groupInsurance: new ReqGroupInsurance({})
        //     })
        // })
    }
    setInsurance(insurance) {
        this.insurance = insurance
    }
}


export function InsuranceCombinationInitInit({ caseContractor, insuredUnitGUI, laborInsuranceLevel_Arr, laborInsuranceType, laborInsuranceStatus, laborInsuranceLevel,
    laborInsuranceDate, healthInsuranceLevel_Arr, healthInsuranceStatus, healthInsuranceDate, healthInsuranceLevel, groupInsuranceGUI, groupInsuranceStatus, groupInsuranceDate }) {
    // console.log(laborInsuranceType)
    // console.log(laborInsuranceLevel)
    if (laborInsuranceLevel_Arr.length === 0 || laborInsuranceType === "" || laborInsuranceLevel === "")
        return
    var laborInsuranceAmount = laborInsuranceLevel_Arr[laborInsuranceType + ""][laborInsuranceLevel - 1]
    // console.log(laborInsuranceAmount)
    var laborInsurance = new ReqLaborInsurance({
        status: laborInsuranceStatus,
        date: laborInsuranceDate,
        amount: laborInsuranceAmount.amount,
        level: laborInsuranceLevel,
    })

    var healthInsuranceAmount = healthInsuranceLevel_Arr[healthInsuranceLevel - 1]
    var healthInsurance = new ReqHealthInsurance({
        status: healthInsuranceStatus,
        date: healthInsuranceDate,
        amount: healthInsuranceAmount.amount,
        level: healthInsuranceLevel,
    })

    var groupInsurance = new ReqGroupInsurance({
        groupInsuranceGUI,
        status: groupInsuranceStatus,
        date: groupInsuranceDate
    })

    var mRespInsurance = new RespInsurance({
        insuredUnitGUI: insuredUnitGUI,
        laborInsurance,
        healthInsurance,
        groupInsurance
    })
    var mReqInsurance = new ReqInsurance({
        caseContractor: caseContractor,
        // insuranceInfo: JSON.stringify(mRespInsurance),
        insuranceInfo: mRespInsurance
    })
    return mReqInsurance
}